import React, {useRef, useEffect} from 'react';
import PropTypes from 'prop-types';
import {getPlayerPoints} from 'helpers/game-helper';
import {scenariosData} from 'data/scenarios-data';
import {defaultMaxPoints} from 'data/points-data';
import Logos from 'components/ui/logos/logos';
import Button from 'components/ui/button/button';
import './result.scss';
import { gameUiTexts } from 'data/ui-texts';
import { renderMarkdown } from 'helpers/text-helper';

const Result = ({scenarioId, playerData, updateBackground, resetGameProgress}) => {	
	/* Timeout */
	const timeout = useRef(null);
	
	/* Points */
	const playerPoints = getPlayerPoints(playerData);
	const scenarioData = scenariosData[scenarioId];
	const maxPoints = scenarioData.tasksData.length * defaultMaxPoints;
	const playerPercentPoints = (maxPoints > 0 ? playerPoints / maxPoints * 100. : 0);
	const playerResult = scenarioData.results.find((r) => {
		return (
			(!r.hasOwnProperty('maxPercentPoints') || r.maxPercentPoints >= playerPercentPoints) &&
			(!r.hasOwnProperty('minPercentPoints') || r.minPercentPoints <= playerPercentPoints)
		);
	});
	const trophy = (playerResult ? playerResult.trophy : null);

	/* Confetti */
	const confettiArray = [];
	if (trophy === 'bronze' || trophy === 'silver' || trophy === 'gold') {
		for (let i = 0; i < 150; i++) {
			confettiArray.push({
				key: i, 
				positionX: Math.random(), 
				randomDelay: Math.random(),
				randomDuration: Math.random(),
				randomZ: parseInt(Math.random() * 99),
				randomR: parseInt(Math.random() * 255),
				randomG: parseInt(Math.random() * 255),
				randomB: parseInt(Math.random() * 255)
			});
		}
	}


	useEffect(() => {
		// Set background image id
		updateBackground('result', scenarioId);

		// Start timer
		timeout.current = setTimeout(() => {
			resetGameProgress();
		}, 60000);

		return () => {
			/* Component will unmount */
			if (timeout.current) clearTimeout(timeout.current);
		};
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="Result">
			<Logos />
			<div className="Result-content">
				<div className="Result-wrap">
					<div className="Result-levels">
						<div className={'Result-level duck' + (trophy === 'duck' ? ' selected' : '')}>
							<div className="Result-levelIcon" />
							<span>Begynder</span>
						</div>
						<div className={'Result-level cup' + (trophy === 'cup' ? ' selected' : '')}>
							<div className="Result-levelIcon" />
							<span>Kender</span>
						</div>
						<div className={'Result-level bronze' + (trophy === 'bronze' ? ' selected' : '')}>
							<div className="Result-levelIcon" />
							<span>Skarp</span>
						</div>
						<div className={'Result-level silver' + (trophy === 'silver' ? ' selected' : '')}>
							<div className="Result-levelIcon" />
							<span>Expert</span>
						</div>
						<div className={'Result-level gold' + (trophy === 'gold' ? ' selected' : '')}>
							<div className="Result-levelIcon" />
							<span>All knowing</span>
						</div>
					</div>
					<div className="Result-box result">
						<div className="Result-header">
							<div className="Result-title">
								<span>{playerResult ? playerResult.title : '-'}</span>	
							</div>
						</div>
						<div className="Result-boxContent">
							<div className="Result-text">
								<span>{playerResult ? playerResult.text : '-'}</span>
							</div>
							<div className={'Result-trophy ' + trophy} />
						</div>
					</div>
					<div className='Result-playAgainBtn'>
						<Button 
							classes={['blueLight', scenarioId, 'responsive']}
							text={gameUiTexts.playAgain}
							onClick={() => {resetGameProgress();}}
						/>
					</div>
				</div>

				<div className="Result-qrCodeWrap">
					<div className="Result-qrText">{renderMarkdown(gameUiTexts.qrCodeText)}</div>
					<div className="Result-qrCode" />
				</div>
			</div>
			<div className='Result-confettiWrapper'>
				{confettiArray.map((confetti) => {
					return (
						<div key={confetti.key} 
							className='Result-fallingConfetti'
							style={{
								left: confetti.positionX * 98 + '%', 
								animationDuration: confetti.randomDuration * 5 + 2 + 's',
								animationDelay: confetti.randomDelay * 5 + 's', 
								zIndex: confetti.randomZ,
							}}>
							<div 
								className='Result-rotatingConfetti'
								style={{
									animationDelay: confetti.randomDelay * 1 + 's',
									animationDuration: confetti.randomDuration + 0.3 + 's',
									backgroundColor: 'rgb(' + 
									confetti.randomR + ',' + 
									confetti.randomG + ',' + 
									confetti.randomB + ')'
								}}
							/>
						</div>
					);
				})}
			</div>
		</div>
	);
};

Result.propTypes = {
	scenarioId: PropTypes.string.isRequired,
	playerData: PropTypes.object.isRequired,
	updateBackground: PropTypes.func.isRequired,
	resetGameProgress: PropTypes.func.isRequired
};

export default Result;
